import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import { getslugId } from '../../helpers/utils'

const settings = {
    className: 'rounded-arrows',
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    autoplay: false,
    responsive: [
        {
            breakpoint: 640, // Adjust this value based on your needs
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ],
}

export default function ProductRow({ section, children }) {
    const Icon = section?.icon
    const superHeading = section?.superHeading
    return (
        <div
            id={getslugId(section.title)}
            className={`${
                section.background
                    ? 'my-12 bg-gradient-to-b from-olm-yellow/10 via-transparent to-olm-yellow/10 pt-12 pb-16 md:rounded-[120px] rounded-[70px]'
                    : 'mt-12 mb-16'
            }`}>
            <div className="xl:max-w-[1400px] lg:max-w-[1200px] w-full mx-auto md:px-0 space-y-6">
                <div className="flex flex-col items-center space-y-8 md:space-y-2 md:px-0">
                    {superHeading && (
                        <div className="text-center px-4">
                            <p className="olm-gradient-text font-semibold text-xl">
                                {superHeading}
                            </p>
                        </div>
                    )}
                    <h2 className="md:space-x-2 md:items-center items-start flex justify-center text-center font-bold md:text-4xl/tight text-3xl/tight space-x-2 w-3/4">
                        {/* <span>{Icon && <Icon className="inline" />}</span> */}
                        <span className="md:flex space-x-1 md:space-x-2 items-center">
                            <span>{Icon && <Icon className="inline" />}</span>
                            <span>{section.title}</span>
                        </span>
                    </h2>
                    {section?.desc && (
                        <p className="md:w-3/4 max-w-2xl text-[#444241] text-center md:text-lg">
                            {section.desc}
                        </p>
                    )}
                </div>
                <div className="lg:flex hidden justify-center space-x-6">
                    {children}
                </div>
                <div className="lg:hidden block">
                    <Slider {...settings}>{children}</Slider>
                </div>
            </div>
        </div>
    )
}
